import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconBBQ: React.FC<IconProps> = ({ width = 26, height = 26, color = 'black' }) => {
    return (
        <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="2" cy="2" r="2" fill={color} />
            <circle cx="10" cy="2" r="2" fill={color} />
            <circle cx="18" cy="2" r="2" fill={color} />
        </svg>
    );
};

export default IconBBQ;
